import './testimonials-popup.html';
import TestimonialsPopup from './testimonials-popup.js';

export default TestimonialsPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/testimonials-popup/index.js